import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NotFoundComponent} from './not-found.component';
import {MainNavBarModule} from '../../Elements/main-nav-bar/main-nav-bar.module';
import {RouterModule} from '@angular/router';



@NgModule({
  declarations: [
    NotFoundComponent
  ],
    imports: [
        CommonModule,
        MainNavBarModule,
        RouterModule
    ],
  exports: [
    NotFoundComponent
  ]
})
export class NotFoundModule { }
